<template>
  <div class="app-skip-nav">
    <a :href="`${route.path}#mainContent`">Skip to main content</a>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/skip-nav";
</style>
